import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../base/hooks";
import { IDetectFaceProps } from "./IDetectFaceProps";

export const DetectFaceProperties = [
    { id: Property.VisionPersonGroupId, name: 'Person Group Id', type: PropertyType.String },
    { id: Property.VisionPersonId, name: 'Person Id', type: PropertyType.String },  
];

export const useDetectFaceProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IDetectFaceProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: IDetectFaceProps = {
            personGroupId: bindings.getValue(Property.VisionPersonGroupId) || '',
            personId: bindings.getValue(Property.VisionPersonId) || '',
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}